import React from 'react';
// import flexible from '../../utils/flexible';
import './index.less';
import hic_mobile_pic1 from './img/20191107.png';

class Banner20191107 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    // document.title = '充电安全须知';
    return (
        <div id="banner">
            <img src={hic_mobile_pic1} />
        </div>
    );
  }
}

export default Banner20191107;



// WEBPACK FOOTER //
// ./src/staticPage/banner/20191107/index.js